/**
 * Bloomer Diamonds - Luxury Countdown Timer Engine
 * High-performance, zero-dependency, timezone-aware, responsive countdown controller.
 * Supports AM/PM, EDT/EST/UTC/IST timezones, ISO dates, and evergreen fallbacks.
 */

(function () {
  'use strict';

  function padZero(num) {
    return String(Math.max(0, Math.floor(num))).padStart(2, '0');
  }

  function parseTargetDate(dateStr, evergreenHours) {
    if (dateStr && typeof dateStr === 'string' && dateStr.trim() !== '') {
      var s = dateStr.trim();

      // Common Timezone offsets
      var tzOffsets = {
        'EDT': '-04:00',
        'EST': '-05:00',
        'CDT': '-05:00',
        'CST': '-06:00',
        'MDT': '-06:00',
        'MST': '-07:00',
        'PDT': '-07:00',
        'PST': '-08:00',
        'IST': '+05:30',
        'UTC': 'Z',
        'GMT': 'Z'
      };

      var tzOffset = '';
      for (var code in tzOffsets) {
        var regex = new RegExp('\\b' + code + '\\b', 'i');
        if (regex.test(s)) {
          tzOffset = tzOffsets[code];
          s = s.replace(regex, '').trim();
          break;
        }
      }

      // Check 12-hour AM / PM format (e.g. "2026-09-03 8:42 PM" or "2026-09-03 08:42:00 PM")
      var ampmMatch = s.match(/^(.*?)\s*(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)(.*)$/i);
      if (ampmMatch) {
        var datePart = ampmMatch[1].trim();
        var h = parseInt(ampmMatch[2], 10);
        var m = ampmMatch[3];
        var sec = ampmMatch[4] || '00';
        var ampm = ampmMatch[5].toUpperCase();
        if (ampm === 'PM' && h < 12) h += 12;
        if (ampm === 'AM' && h === 12) h = 0;
        var hStr = String(h).padStart(2, '0');
        var trailing = tzOffset || (ampmMatch[6] ? ampmMatch[6].trim() : '');
        s = datePart + 'T' + hStr + ':' + m + ':' + sec + trailing;
      } else {
        // Standard 24h format: replace space with T
        s = s.replace(/^(\d{4}-\d{2}-\d{2})\s+(\d{1,2}:\d{2}(?::\d{2})?)/, '$1T$2');
        if (tzOffset && !/[Z+-]\d{2}(?::\d{2})?$/.test(s)) {
          s += tzOffset;
        }
      }

      var parsed = new Date(s);
      if (!isNaN(parsed.getTime())) {
        var now = Date.now();
        if (parsed.getTime() > now) {
          return parsed.getTime();
        }
      }
    }

    // Evergreen fallback: 24h cycle
    var hours = parseInt(evergreenHours, 10) || 24;
    var storageKey = 'bloomer_timer_deadline_' + hours;
    var savedDeadline = localStorage.getItem(storageKey);
    var nowMs = Date.now();

    if (savedDeadline && parseInt(savedDeadline, 10) > nowMs) {
      return parseInt(savedDeadline, 10);
    }

    var newDeadline = nowMs + hours * 60 * 60 * 1000;
    try {
      localStorage.setItem(storageKey, String(newDeadline));
    } catch (e) {}
    return newDeadline;
  }

  function initTimer(timerElement) {
    if (!timerElement) return;

    var dateStr = timerElement.getAttribute('data-end-date') || '';
    var evergreenHours = timerElement.getAttribute('data-evergreen-hours') || '24';
    var targetTimestamp = parseTargetDate(dateStr, evergreenHours);

    var daysEl = timerElement.querySelector('[data-days]');
    var hoursEl = timerElement.querySelector('[data-hours]');
    var minsEl = timerElement.querySelector('[data-minutes]');
    var secsEl = timerElement.querySelector('[data-seconds]');

    if (timerElement._timerInterval) {
      clearInterval(timerElement._timerInterval);
    }

    function update() {
      var now = Date.now();
      var diff = targetTimestamp - now;

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minsEl) minsEl.textContent = '00';
        if (secsEl) secsEl.textContent = '00';
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = padZero(days);
      if (hoursEl) hoursEl.textContent = padZero(hours);
      if (minsEl) minsEl.textContent = padZero(minutes);
      if (secsEl) secsEl.textContent = padZero(seconds);
    }

    update();
    var intervalId = setInterval(update, 1000);
    timerElement._timerInterval = intervalId;
    timerElement.dataset.timerInitialized = 'true';
  }

  function initAllTimers() {
    var timers = document.querySelectorAll('[data-countdown-timer]');
    timers.forEach(function (t) {
      initTimer(t);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTimers);
  } else {
    initAllTimers();
  }

  // Shopify Theme Editor live reload hooks
  document.addEventListener('shopify:section:load', function (event) {
    var newTimers = event.target.querySelectorAll('[data-countdown-timer]');
    newTimers.forEach(function (t) {
      initTimer(t);
    });
  });

  document.addEventListener('shopify:section:select', function (event) {
    var newTimers = event.target.querySelectorAll('[data-countdown-timer]');
    newTimers.forEach(function (t) {
      initTimer(t);
    });
  });

  // Global export
  window.BloomerCountdown = {
    init: initAllTimers,
    initTimer: initTimer,
    parseTargetDate: parseTargetDate
  };
})();
